import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import AdPositionOptions from "../../../components/serverList/adPositionOptions.vue";
import { adGameDataCount } from "@/api/data";
import { getAdPositionMap } from "@/utils/dictionary";
import exportCsv from "@/mixins/exportCsv";
export default {
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    AdPositionOptions: AdPositionOptions
  },
  mixins: [exportCsv],
  data: function data() {
    return {
      tableData: [],
      searchInfo: {
        sdate: "",
        edate: "",
        server_id: ["0"],
        position_id: ["0"]
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      adPositionMap: {}
    };
  },
  methods: {
    searchEvent: function searchEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.formData[0];
              _this.searchInfo.edate = _this.formData[1];
              _context.next = 4;
              return adGameDataCount(_this.searchInfo);
            case 4:
              res = _context.sent;
              if (res.code == 0 && res.data.list && res.data.list.length > 0) {
                _this.tableData = res.data.list;
              } else {
                _this.tableData = [];
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    exportEvent: function exportEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      var url = "/api/xcpGameData/payAnalysis/exportAdGameDataCount?";
      this.exportCsv(url, this.searchInfo, "1");
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAdPositionMap();
          case 2:
            _this2.adPositionMap = _context2.sent;
            _this2.$nextTick(function () {
              _this2.searchEvent();
            });
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};